import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "elem-map-box" }
const _hoisted_2 = { class: "map-input-box" }
const _hoisted_3 = { class: "result-box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "district" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "map-container-box",
  id: "map_container"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_input_object = _resolveComponent("elem-input-object")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_elem_input_object, {
      name: $props.name,
      value: $data.input_value,
      title: $props.title,
      required: $props.required,
      getValue: $options.getValue
    }, null, 8, ["name", "value", "title", "required", "getValue"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.input_value) = $event)),
        type: "text",
        placeholder: "输入地址",
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onInput && $options.onInput(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.onFocus && $options.onFocus(...args))),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.onBlur && $options.onBlur(...args)))
      }, null, 544), [
        [_vModelText, $data.input_value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.result, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item-box",
            key: idx,
            onClick: ($event: any) => ($options.onSelectResult(item))
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.name), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.district), 1)
          ], 8, _hoisted_4))
        }), 128))
      ], 512), [
        [_vShow, $data.display_result && $data.result && $data.result.length > 0]
      ])
    ]),
    _hoisted_7
  ]))
}